var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.view === 'signup')?_c('div',[_c('SignUpComponent',{on:{"switch-view":_vm.switchView,"signup-success":_vm.redirectToCustomize}})],1):_vm._e(),(_vm.view === 'login')?_c('div',[_c('LogInComponent',{on:{"switch-view":_vm.switchView,"login-success":_vm.redirectToCustomize}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }